import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressBar } from '@kubit/web-ui-components/progressBar';
import { MultipleProgressBarsContainerStyled, ParentMultipleProgressBarsContainerStyled, } from '../progressBarComplex.styled';
export const MultipleProgressBars = (props) => {
    return (_jsx(ParentMultipleProgressBarsContainerStyled, { styles: props.styles, children: props.progressBars.map((progressBar, index) => {
            return (_jsx(MultipleProgressBarsContainerStyled, { styles: props.styles, children: _jsx(ProgressBar, { size: props.styles.kubitProgressBar.size, variant: props.styles.kubitProgressBar.variant, ...progressBar }) }, index));
        }) }));
};
//# sourceMappingURL=multipleProgressBars.js.map